import { Component, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'ac-pdf-benchmark-option',
	templateUrl: './pdf-benchmark-option.component.html',
	styleUrls: ['./pdf-benchmark-option.component.scss']
})
export class PdfBenchmarkOptionComponent {
	@Output() public includeBenchmarkChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public includeBenchmark: boolean = true;

	public toggleBenchmark(): void {
		this.includeBenchmark = !this.includeBenchmark;
		this.includeBenchmarkChange.emit(this.includeBenchmark);
	}
}
